class EmissionFactors {
  constructor({ id, _id, year, fe, factor_unity, type }) {
    this.id = id || _id;
    this.year = year;
    this.fe = fe;
    this.factor_unity = factor_unity;
    this.type = type;
  }
}

export default EmissionFactors;